import { useTranslation } from 'react-i18next'

import useSessionUser from '@/modules/access/hooks/useSessionUser'
import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import BudgetIcon from '@/modules/shared/icons/BudgetIcon'
import { PlusIcon } from '@/modules/shared/icons/PlusIcon'
import SideNavLink, { SideNavLinkItem } from '@/modules/shared/layouts/side-navigation/SideNavLink'
import { SideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import { Themes } from '@/modules/shared/types/Themes'

interface BudgetsSideBarItemProps extends SideBarItem {
  budgetRoutesMatch: boolean
}

export const BudgetsSideBarItem = ({
  budgetRoutesMatch,
  openAccordionKey,
  changeOpenAccordionKey,
  onCloseDrawer,
  sideBarIndexKey,
}: BudgetsSideBarItemProps) => {
  const { t } = useTranslation()

  const { userPermissions } = useSessionUser()

  const getSideNavLinkItems = () => {
    const sideNavItems: SideNavLinkItem[] = []
    if (userPermissions?.PURCHASER_CAN_MANAGE_BUDGETS) {
      sideNavItems.push({
        key: t('general.newBudget', 'New Budget'),
        target: '/budgets/create',
        icon: <PlusIcon className="size-6 text-gray-500" />,
      })
    }
    sideNavItems.push({
      key: t('general.viewAll', 'View All'),
      target: '/budgets',
    })
    return sideNavItems
  }

  return (
    <Accordion
      titlePrefixIcon={<BudgetIcon className="size-7" />}
      title={t('general.budgets', 'Budgets')}
      activeColor={budgetRoutesMatch ? Themes.Primary : undefined}
      defaultOpen={openAccordionKey === sideBarIndexKey}
      handleTriggerClick={() => changeOpenAccordionKey(sideBarIndexKey)}
      buttonClassName="min-h-11 px-3"
      keepActiveColor
    >
      <SideNavLink
        onCloseDrawer={() => onCloseDrawer()}
        testId="budget-navigation"
        sideNavLinkItems={getSideNavLinkItems()}
      />
    </Accordion>
  )
}
